import NeptuneElement from '../../NeptuneElement.js';

class Badge extends NeptuneElement {

    templateMarkup = `<span class="font-size-sm" aria-hidden="true"></span>`;

    componentCssUrl = '/src/components/core/badge/badge.css';

    constructor() {
        super();
    }

    static get observedAttributes() {
        return ['count'];
    }

    async connectedCallback() {
        await super.connectedCallback();
        this.setAttribute('role', 'status');
        this.setAttribute('aria-atomic', 'true');
        this.processInitialAttributesAfterRender(Badge.observedAttributes);
        
        if (!this.hasAttribute('count')) {
            this.processAttribute('count', null, null);
        }
    }

    async disconnectedCallback() {
        await super.disconnectedCallback();
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (!this.isRendered) {
            return;
        }
        this.processAttribute(name, oldValue, newValue);
    }

    processAttribute(name, oldValue, newValue) {
        switch (name) {
            case 'count': {
                const span = this.shadowRoot?.querySelector('span');
                if (!span) return;

                if (newValue === null) {
                    this.setAttribute('dot', '');
                    span.textContent = '';
                    this.setAttribute('aria-label', 'New notification');
                } else {
                    this.removeAttribute('dot');
                    const numeric = parseInt(newValue, 10);
                    if (Number.isInteger(numeric) && numeric > 99) {
                        span.textContent = '99+';
                        this.setAttribute('aria-label', 'More than 99 notifications');
                    } else {
                        span.textContent = String(numeric);
                        this.setAttribute('aria-label', `${numeric} notification${numeric !== 1 ? 's' : ''}`);
                    }
                }
                break;
            }
            default:
                break;
        }
    }
}

customElements.define('neptune-badge', Badge);
export default Badge;